import client from "./requestclient";

const properties = {
  fetchForRent: async () => {
    return await client({ URL_PATH: `fetchpropertiesrandomly`, method: "GET" });
  },

  fetchForSale: async () => {
    return await client({ URL_PATH: `fetchpropertiesforsale`, method: "GET" });
  },
  lanlordsList: async (id) => {
    return await client({ URL_PATH: `fetch-smart-associate-added-landlords/${id}`, method: "GET" });
  },
  fetchPropertyType: async () => {
    return await client({ URL_PATH: `fetchpropertytypes`, method: "GET" });
  },
  fetchPropertySubType: async id => {
    return await client({
      URL_PATH: `fetchpropertysubtypesbytypeid/${id}`,
      method: "GET"
    });
  },
  fetchBusinessTypes: async () => {
    return await client({
      URL_PATH: "newfetchbusinesstypes",
      method: "GET"
    });
  },
  fetchPropertyStatuses: async () => {
    return await client({
      URL_PATH: `fetchpropertystatuses`,
      method: "GET"
    });
  },
  fetchPropertyFacilities: async () => {
    return await client({
      URL_PATH: `fetchfacilities`,
      method: "GET"
    });
  },
  tenantVerification: async body => {
    return await client({
      URL_PATH: "verify-tenant",
      method: "POST",
      body: body
    });
  },
  addNewUnit: async body => {
    return await client({
      URL_PATH: "add-units-to-property",
      method: "POST",
      body: body
    });
  },
  fetchStates: async () => {
    return await client({
      URL_PATH: `fetchstatesbycountryid/161`,
      method: "GET"
    });
  },
  fetchCities: async (id) => {
    return await client({
      URL_PATH: `fetchcitiesbystateid/${id}`,
      method: "GET"
    });
  },
  fetchPropCategory: async () => {
    return await client({
      URL_PATH: `fetch-shelta-property-categories`,
      method: "GET"
    });
  },
  fetchPropertyAwarenessTypes: async () => {
    return await client({
      URL_PATH: "fetchpropertyawarenestypes",
      method: "Get"
    });
  },
  verifyEmail: async email => {
    return await client({
      URL_PATH: `checkuserwithemailexist/${email}`,
      method: "GET"
    });
  },
  registerIdentifiedProperty: async body => {
    return await client({
      URL_PATH: "processaddpropertyrepository",
      method: "POST",
      body: body
    });
  },
  tenantBioData: async body => {
    return await client({
      URL_PATH: "tenant-onboarding-biodata",
      method: "POST",
      body: body
    });
  },

  tenantEmagencyData: async body => {
    return await client({
      URL_PATH: "tenant-onboarding-emergency-contact",
      method: "POST",
      body: body
    });
  },

  tenantGuarantorData: async body => {
    return await client({
      URL_PATH: "tenant-onboarding-guarantor",
      method: "POST",
      body: body
    });
  },
  tenantNextOfKinData: async body => {
    return await client({
      URL_PATH: "tenant-onboarding-next-of-kin",
      method: "POST",
      body: body
    });
  },

  tenantBusinessData: async body => {
    return await client({
      URL_PATH: "tenant-self-employed-or-enterpreneur-or-business-details",
      method: "POST",
      body: body
    });
  },

  tenantEmployedNgoData: async body => {
    return await client({
      URL_PATH: "tenant-employed-or-ngo-details",
      method: "POST",
      body: body
    });
  },

  tenantUnemployedRetiredData: async body => {
    return await client({
      URL_PATH: "tenant-unemployed-or-retired-details",
      method: "POST",
      body: body
    });
  },

  partnerReassignRequest: async body => {
    return await client({
      URL_PATH: "partner-reassign-property",
      method: "POST",
      body: body
    });
  },


  fetchOccupationTypes: async () => {
    return await client({
      URL_PATH: `fetchoccupationtypes`,
      method: "GET"
    });
  },
  registerLandlordStandAlone: async body => {
    return await client({
      URL_PATH: "smart-add-landlord",
      method: "POST",
      body: body,
      bodyType: "FormData"
    });
  },
  updateLandlordDetails: async body => {
    return await client({
      URL_PATH: "smart-edit-landlord",
      method: "POST",
      body: body
    });
  },
  updateLandlordDetailsFormData: async body => {
    return await client({
      URL_PATH: "smart-edit-landlord",
      method: "POST",
      body: body,
      bodyType: "FormData"
    });
  },
  registerPropertyToLandlordStandAlone:  async (body, url) => {
    return await client({
      URL_PATH: `${url}`,
      method: "POST",
      body: body
    });
  },

  updateGeneralPropertyDetails: async (body, url) => {
    return await client({
      URL_PATH: `${url}`,
      method: "POST",
      body: body
    });
  },

  updateSingleUnit: async body => {
    return await client({
      URL_PATH: "editpropertyunit",
      method: "POST",
      body: body,
    });
  },

  agentRegisterProperty: async body => {
    return await client({
      URL_PATH: "smart-agent-upload-property",
      method: "POST",
      body: body
    });
  },
  uploadPropertyEvidenceOfOwener: async (formData) => {
    return await client({
      URL_PATH: "uploadevidenceofownership",
      method: "POST",
      body: formData,
      bodyType: "FormData"
    });
  },
  uploadPropertyEvidenceOfOwenerUpdate: async (formData) => {
    return await client({
      URL_PATH: "edit-property-proof-of-ownership-by-batch",
      method: "POST",
      body: formData,
      bodyType: "FormData"
    });
  },

  uploadPropertyimages: async (formData) => {
    return await client({
      URL_PATH: "uploadpropertyimage",
      method: "POST",
      body: formData,
      bodyType: "FormData"
    });
  },
  // uploadPropertyimages2: async (formData) => {
  //   return await client({
  //     URL_PATH: "uploadimportantfile",
  //     method: "POST",
  //     body: formData,
  //     bodyType: "FormData"
  //   });
  // },
  fetchFacilitiess: async () => {
    return await client({
      URL_PATH: `fetchfacilities`,
      method: "GET"
    });
  },
  fetchAgentProperties: async (id) => {
    return await client({
      URL_PATH: `smart-agent-properties-by-id/${id}`,
      method: "GET"
    });
  },
  fetchAgentPropertiesById: async (id) => {
    return await client({
      URL_PATH: `fetchpropertybyid/${id}`,
      method: "GET"
    });
  },

  fetchAgentPropertiesByIdFilter: async (id, stateId, date) => {
    return await client({
      URL_PATH: `filter-agent-properties-by-date-and-state-id/${id}?state_id=${stateId}&date=${date}`,
      method: "GET"
    });
  },

  agentDeleteSinglePropertyImage: async body => {
    return await client({
      URL_PATH: "delete-property-image",
      method: "POST",
      body: body
    });
  },
  updatingPropertyImages: async body => {
    return await client({
      URL_PATH: "edit-property-images-by-batch",
      method: "POST",
      body: body
    });
  },
  updatingPropertyOwnwershipDoc: async body => {
    return await client({
      URL_PATH: "edit-property-proof-of-ownership-by-batch",
      method: "POST",
      body: body
    });
  },

  fetchPartnersPropertiesById: async (id) => {
    return await client({
      URL_PATH: `fetch-partner-properties/${id}`,
      method: "GET"
    });
  },

  fetchPartnersLandlordsById: async (id) => {
    return await client({
      URL_PATH: `fetch-partner-landlords/${id}`,
      method: "GET"
    });
  },

  fetchPropertiesByBatch: async (batch) => {
    return await client({
      URL_PATH: `fetch-property-by-batch/${batch}`,
      method: "GET"
    });
  },

  fetchProperttUnitById: async (id) => {
    return await client({
      URL_PATH: `get-unit-details-by-id/${id}`,
      method: "GET"
    });
  },


  fetchLandlordDetailsById: async (id) => {
    return await client({
      URL_PATH: `get-landlord-details-by-id/${id}`,
      method: "GET"
    });
  },

  tenantMeansOfID: async (formData) => {
    return await client({URL_PATH: "tenant-onboarding-mode-of-identity", method: "POST", body: formData, bodyType: "FormData"});
  },
};

export default properties;
